import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['body']

  sort(event) {
    const header = event.currentTarget
    const index = parseInt(header.dataset.sortIndex, 10)
    const ascending = header.dataset.sortDirection !== 'asc'

    const rows = Array.from(this.bodyTarget.rows)
    rows.sort((a, b) => {
      const first = a.cells[index].dataset.sortValue ?? ''
      const second = b.cells[index].dataset.sortValue ?? ''
      const firstNumber = parseFloat(first)
      const secondNumber = parseFloat(second)
      const comparison =
        !isNaN(firstNumber) && !isNaN(secondNumber)
          ? firstNumber - secondNumber
          : first.localeCompare(second)
      return ascending ? comparison : -comparison
    })

    rows.forEach((row) => this.bodyTarget.appendChild(row))

    this.element
      .querySelectorAll('[data-sort-index]')
      .forEach((element) => delete element.dataset.sortDirection)
    header.dataset.sortDirection = ascending ? 'asc' : 'desc'
  }
}
